import { render } from "./TabSamCartsList.vue?vue&type=template&id=06657485"
import script from "./TabSamCartsList.vue?vue&type=script&lang=js"
export * from "./TabSamCartsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__